import { HeadingTitle } from "../ModalContainer";
import secureLocalStorage from "react-secure-storage";
import { Button } from "@material-ui/core";
import Dropdown from "../../Dropdown/Dropdown";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { filterById } from "../../../Middleware/CommonFun";
import Loading from "../../Loading/Loading";
import InputField from "../../InputField/InputField";
import axios from "axios";
import { toast } from "react-toastify";
import { BASEURI } from "../../../Middleware/axiosInstance";

const AddReason = ({
    close,
    departmentList,
    reCallAPI,
    setReCallAPI
}) => {

    const token = JSON.parse(secureLocalStorage.getItem("user_UUID_MFG"))?.token;
    const dispatch = useDispatch();

    const [reason_name, set_reason_name] = useState('');
    const [department_id, set_department_id] = useState('');

    const handleReasonName = (e) => {
        set_reason_name(e)
    }

    const [addReasonLoading, setAddReasonLoading] = useState(false)

    const handleSubmit = () => {
        axios.post(`${BASEURI}`, {
            service_name: "save_inventory_temp_hold_reason",
            token: token,
            name: reason_name,
            dept_id : department_id.value
        })
        .then((result) => {
            if (result.data.status == 1) {
                setReCallAPI(!reCallAPI)
                toast.success(result.data.msg)
                close();
            } else {
                toast.error(result.data.msg)
            }
        })
        .catch(() => {
            toast.error('Somethinng went wrong')
        })
    }

    return (
        <div>
            <HeadingTitle title={`Add Reason`} center={false} closeModal={close} />
            <>
                <div className="mtx1-3">
                    <div>
                        <InputField
                            label={"Reason Name"}
                            placeholder={"Enter Name"}
                            onChange={handleReasonName}
                            name={"reason_name"}
                        />
                    </div>
                </div>
                <div className="mtx5-3">
                    <Dropdown
                        dropdown={departmentList}
                        placeholder="Select Department"
                        label="Select"
                        onData={(value) => set_department_id(value)}
                    />
                </div>
                <div className="center__cta text-center">
                    <Button
                        className="add-btn"
                        onClick={handleSubmit}
                        style={{ backgroundColor: "#46CC8D" }}
                    >
                        {addReasonLoading ? (
                            <Loading color={"#ffffff"} size={18} />
                        ) : (
                            "Submit"
                        )}
                    </Button>
                </div>
            </>
        </div>
    );
};

export default AddReason;
